window.addEventListener("hoContentLoaded", () => {
	//console.log("color.js _ hoContentLoaded");

	Vue.component('set-background-color', {
		data: () => ({
			prev : null,
		}),
		methods: {
			viewportIn()
			{
				this.setStyle(this.$el.dataset.background,this.$el.dataset.fontInverted);
			},

			setStyle(backgroundColor,fontInverted)
			{
				const r = document.querySelector(':root');
				r.style.setProperty('--color-background', backgroundColor);

				if(fontInverted === "0")
				{
					r.style.setProperty('--color', "--color-invert");
				}
				else
				{
					r.style.setProperty('--color', "--color");
				}
			},

			viewportOut(entry,scrollDirection)
			{
				if(scrollDirection === -1)
				{
					this.setStyle(this.prev.dataset.background,this.prev.dataset.fontInverted);
				}
				else if(scrollDirection === 1)
				{

				}
			}
		},

		mounted () {
			const nodeList = document.querySelectorAll(".set-background-color");

			for (let i = 0; i < nodeList.length; i++)
			{
				if(nodeList[i].dataset.id === this.$el.dataset.id)
				{
					if(nodeList[i-1] !== null)
					{
						this.prev = nodeList[i-1];
					}
				}
			}

			window.viewport.add(this);
		},
	});
});
